export default "__VITE_ASSET__CuBXf9zf__"